import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GroupPermissionContainer'

    static propTypes = {
      checked: PropTypes.bool.isRequired,
      handleSelection: PropTypes.func.isRequired,
      permission: PropTypes.object.isRequired,
    }

    onSelect = () => {
      const { handleSelection, permission } = this.props

      handleSelection(permission.key)
    }

    render() {
      return <WrappedComponent onSelect={this.onSelect} permission={this.props.permission} checked={this.props.checked} />
    }
  }

  return Container
}
